const sv = {
  swedish: 'Svenska',
  english: 'English',
  frontPage: {
    heading: 'Startsida',
    preamble: 'Välj en kommun i listan nedan för att börja använda tjänsten:',
    loadMunicipalitiesError: 'Vi upplever tekniska problem, vi ber dig pröva igen senare',
  },
  topMenu: {
    language: 'Language',
    swedish: 'Svenska',
    english: 'English',
    aboutMunicipality: 'Om kommunen',
    aboutService: 'Om tjänsten',
  },
  aboutService: {
    header: 'Välkommen hit',
    subHeader: 'Sveriges första digitala inflyttningsguide',
    sectionMotivation: {
      header: 'Varför Välkommen hit?',
      content: 'Målet med Välkommen hit är att införa en digitaliserad lösning som ger vägledning och information för att stimulera inflyttning till en plats och att tillgängliggöra information för att förstärka kommunens attraktionskraft för potentiella inflyttare, kommunmedborgare och etableringar. Välkommen hit ska bidra till att:',
      ul: [
        'Öka attraktiviteten som gör att folk trivs där de bor.',
        'Platser kan växa genom inflyttning av nya människor.',
        'Arbetsgivare får stöd i att attrahera efterfrågad kompetens genom tjänsten.',
        'Personer som nyttjat tjänsten anser att den är bra/värdefull/önskvärd.',
        'Antalet samtal och inkommande e-post minskar och att färre vidareskickningar frågor sker inom och mellan förvaltningar.',
      ],
    },
    sectionBackground: {
      header: 'Bakgrund',
      content: 'Välkommen hit inleddes som ett samarbete mellan nio kommuner inom projektet eSamverkan där målet var att öka inflyttningen till respektive kommun och effektivisera inflyttningsprocessen. Utvecklingen av digitalisering fokuserar på att förenkla för medborgare och företagare att hantera sina kontakter med kommunen med hjälp av moderna kommunikationskanaler. För att få full utväxling av de möjligheter digitaliseringen ger behöver sannolikt de interna processerna utvecklas så att de drar nytta av de nya potentialerna.',
    },
    sectionConnect: {
      header: 'Anslut er till Välkommen hit',
      contentP1: 'Tjänsten som erbjuds som en Software-as-a-Service (SaaS) har utvecklats av Dewire Consultants AB.',
      contentP2: 'Vill du veta mer om hur du kan ansluta din kommun, besök oss på: ',
      href: 'https://www.dewire.com/valkommen-hit',
    },
    sectionAccessibility: {
      header: 'Tillgänglighet och samtycke',
      content: 'Tjänsten överensstämmer med följande riktlinjer för tillgänglighet och samtycke:',
      ul: [
        { title: 'GDPR/Dataskyddsförordningen ', href: 'https://www.datainspektionen.se/dataskyddsreformen/dataskyddsforordningen/' },
        { title: 'WCAG 2.0 AA ', href: 'https://www.w3.org/TR/WCAG20/' },
        { title: 'Cookies och tracking ', href: 'http://www.pts.se/sv/bransch/regler/lagar/lag-om-elektronisk-kommunikation/kakor-cookies/' },
      ],
    },
    readMore: 'Läs mer',
    thirdParty: 'Programvara från tredje part',
    pageTitle: 'Välkommen hit - Om tjänsten',
  },
  general: {
    noPageHeaderSv: 'Sidan kunde inte hittas (Fel 404)',
    noPageHeaderEn: 'Page not found (Error 404)',
    noPageMessageSv: 'Något gick fel när sidan skulle besökas, vänligen kontrollera angiven länk, språk och kommun.',
    noPageMessageEn: 'Something went wrong when visiting the site, please check link, language and municipality.',
  },
  commutePinModal: {
    header: 'Välj pendlingsdestination',
    contentP1: 'Det verkar vara första gången du använder tjänsten, för att göra din upplevelse bättre så kan du välja en pendlingsdestination.',
    contentP2: 'Denna kommer användas för att beräkna restider från respektive område i tjänsten.',
    contentP3: 'Ifall du inte väljer en destination så kommer den förifyllda att användas.',
  },
  feedbackModal: {
    title: 'Feedback på tillgänglighet',
    description: 'Vi strävar alltid efter att uppfylla de krav som ställs på att våran webbplats ska vara tillgänglig för alla. Om du upplever att vi inte följer WCAG eller att vi brister i tillgängligheten ser vi gärna att du kontaktar oss och berättar så att vi kan göra tjänsten bättre.',
    messageLabel: 'Meddelande',
    buttonText: 'Skicka',
  },
  subscriptionModal: {
    title: 'Anmäl dig för informationsmail',
    description: 'Vill du få information om jobb, examensarbeten eller events? Fyll i formuläret nedan.',
    name: 'Namn',
    mail: 'Mail',
    role: 'Är du student eller arbetar du?',
    school: 'Vart studerar du?',
    education: 'Vilket program läser du?',
    year: 'Vilket studieår läser du?',
    location: 'Vart bor du?',
    roles: {
      STUDENT: 'Studerar',
      WORKING: 'Arbetar',
      LOOKING_FOR_WORK: 'Arbetssökande',
    },
    privacy: {
      description: 'Läs och godkänn vår hantering av personuppgifter',
      accept: 'Jag godkänner',
    },
    submit: 'Registrera',
    mailInvalid: 'Kräver en fungerande mail-address',
    successToast: 'Din registrering är sparad',
    failureToast: 'Något gick fel, försök igen',
  },
  gdprModal: {
    header: 'GDPR Policy',
    label1: 'Personuppgifter som behandlas',
    p1: 'Namn, E-post, IP-adress, Cookies',
    label2: 'Ändamålet med behandlingen',
    p2: 'Kunna göra riktade informationsutskick till lämplig målgrupp',
    label3: 'Laglig grund för behandlingen',
    p3: 'Samtycke',
    label4: 'Lagringstid',
    p4: '5 år',
    label5: 'Mottagare av personuppgifter',
    label6: 'Övriga upplysningar',
    label7: 'Lämna klagomål på personuppgiftshantering',
    p7: 'Klagomål rörande personuppgiftshanteringen i tjänsten kan lämnas till tillsynsmyndigheten, Datainspektionen. Besök Datainspektionens hemsida för mer information',
    p7_2: 'Datainspektionen',
    label8: 'Personuppgiftsansvarig',
  },
  questionModal: {
    title: 'Fråga oss',
    description: 'Ställ en fråga till oss så svarar vi så fort vi kan!',
    name: 'Namn',
    mail: 'Mailadress',
    question: 'Fråga',
    privacy: {
      description: 'Läs och godkänn vår hantering av personuppgifter',
      accept: 'Jag godkänner',
    },
    submit: 'Skicka',
    mailInvalid: 'Kräver en giltig mailadress',
    successToast: 'Din fråga har skickats',
    failureToast: 'Något gick fel, försök igen',
  },
  municipalityPage: {
    pageTitle: 'Välkommen hit - ',
    aboutMunicipality: 'Om kommunen',
    aboutService: 'Om tjänsten',
    language: 'Language',
    explore: 'Utforska',
    teacherCallToAction: 'Lärare eller lärarstudent? Se hit!',
    start: 'Start',
    information: 'Information',
    moveTo: 'Flytta till ',
  },
  careerPage: {
    aboutMunicipality: 'Om kommunen',
    aboutService: 'Om tjänsten',
    language: 'Language',
    explore: 'Utforska',
    start: 'Start',
    information: 'Information',
    moveTo: 'Flytta till ',
    registerMail: 'Nyhetsbrev',
    submitQuestion: 'Fråga oss',
  },
  mapView: {
    satellite: 'Satellit',
    map: 'Karta',
    areas: 'Områden: ',
    clearFilter: 'Rensa filter',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    reload: 'Sök på nytt',
  },
  navbar: {
    filter: 'Sökfilter',
    favorites: 'Favoriter',
    contact: 'Kontakt',
    career: 'Karriär',
  },
  tabSearch: {
    searchArea: 'Sök område',
  },
  tabFilter: {
    heading: 'Filtrera',
    preamble: 'Här kan du filtrera vilka områden som visas på kartan genom att välja vilken typ av boende du föredrar samt hur länge du max vill pendla till den valda platsen.',
    housingPreference: 'Jag vill bo i:',
    house: 'Hus',
    apartment: 'Lägenhet',
    commute: 'Plats dit du vill pendla:',
    commuteMax: 'Max pendlingsavstånd',
    showOnMap: 'Visa på karta',
    showMore: 'Visa fler…',
    clearFilter: 'Rensa filter',
    send: 'Skicka',
    shareDescription: 'Kopiera länken nedan för att dela dina nuvarande filterinställningar.',
  },
  tabCareer: {
    heading: 'Karriärtillfällen i ',
    contentP1: 'Är du student och närmar dig examen eller har du lång erfarenhet i ditt yrke och letar nya utmaningar? I vår kommun finns möjligheter!',
    contentP2: 'Klicka in på någon av våra karriärssidor för att få information och möjlighet att ställa frågor.',
  },
  tabContact: {
    contact: 'Kontakt',
    desc: {
      first: 'Jag heter ',
      second: ' och arbetar som ',
      title: 'inflyttningslots',
      last: '. Kontakta mig om du har frågor eller funderingar om exempelvis:',
    },
    checklist: {
      housing: 'Boende och bostadsmarknad',
      school: 'Skola',
      work: 'Jobb till medflyttare',
      visit: 'Arrangera förhandsbesök',
      activities: 'Fritidsaktiviteter',
      childcare: 'Barnomsorg',
      other: 'Annat bra att tänka på vid flytt hit',
    },
    mailBtn: 'Maila mig',
  },
  tabFavourites: {
    heading: 'Mina favoriter',
    preamble: 'Här kan du spara dina favoritområden, och dela dom med exempelvis en medflyttare. Du kan även jämföra områden med varandra.',
    sortBy: 'Favoriter sorterade efter:',
    vicinity: 'Närhet',
    compare: 'Jämför',
    deselectAll: 'Avmarkera alla',
    selectAll: 'Markera alla',
    removeSelected: 'Ta bort markerade',
    km: 'km',
    noFavs: 'Du har inte sparat några favoriter ännu! \n\n Klicka på ett område på kartan och spara som favorit.',
    toMap: 'Till karta',
    sortOptions: 'SORTERINGSALTERNATIV:',
    asc: 'A-Ö',
    removePrompt: 'Är du säker på att du vill ta bort valda områden?',
    sharePreamble: 'Valda områden att dela:',
    shareDescription: 'Den delbara länken visar en jämförelseöversikt av valda områden.',
    maxCompare: 'Du kan endast jämföra 10 favoriter åt gången. \n\n Avmarkera favoriter och försök igen.',
    maxShare: 'Du kan endast dela 10 favoriter åt gången. \n\n Avmarkera favoriter och försök igen.',
  },
  streetView: {
    heading: ' i Google Street View',
    preamble: 'Är du intresserad av hur området med omnejd ser ut på gatunivå? Med hjälp av Google Street View så kan du i egen takt gå runt och utforska en virituell representation av området. Ta en tur i området med Google Street View',
  },
  housingListings: {
    noResults: 'För närvarande så verkar det inte finnas några bostäder till salu i området.',
    newlyListed: 'Nyligen utlagt till försäljning',
    visit: 'Besök',
    moreForSale: 'för att se fler bostäder till salu',
    housingItem: {
      rooms: 'rum',
      month: 'mån',
      plot: 'tomt',
      today: 'Idag',
      yesterday: 'Igår',
      days: 'dagar',
      detached: 'Villa',
      apartment: 'Lägenhet',
      farm: 'Gård',
      plotType: 'Tomt-mark',
      cottage: 'Fritidshus',
      semiDetached: 'Parhus',
      terraced: 'Radhus',
    },
  },
  areaCarousel: {
    headingMunicipality: 'Utforska områden:',
    headingArea: 'Fler områden att utforska:',
  },
  commuteTime: {
    heading: 'Restid och pendlingsavstånd',
    preamble: 'Undrar du hur lång tid det ta att pendla med cykel till en potentiell arbetsplats? Eller kanske hur lång tid det tar att promenera till en närliggande matbutik? Använd fältet nedan för att söka fram platsen dit du vill pendla för att se restider.',
    whereTo: 'Vart vill du pendla?',
    toPlaceholder: 'Till: ',
    yourResult: 'Ditt resultat:',
    fromPlaceholder: 'Från: ',
    publicTimeNote: 'Förväntad restid vid ankomst klockan 8:00 på morgonen',
  },
  area: {
    readMore: 'Visa mer',
    saveArea: 'Spara område',
    sendArea: 'Skicka område',
  },
  common: {
    yes: 'Ja',
    cancel: 'Avbryt',
    km: 'km',
    copyLink: 'Kopiera länk',
    share: 'Dela',
    close: 'Stäng',
    next: 'Nästa',
    prev: 'Föregående',
    check: 'Bocka',
    uncheck: 'Avbocka',
    areaLinks: 'Länksamling för områden',
  },
  factBox: {
    pharmacy: 'Avstånd till apotek',
    groceryStore: 'Avstånd till mataffär',
    hospital: 'Avstånd till sjukhus',
    medicalCenter: 'Avstånd till vårdcentral',
    commuteDestination: 'Avstånd till',
    averageHouseCost: 'Snittpris för villor',
    averageFlatCost: 'Snittpris för lägenheter',
  },
  compare: {
    compareFavs: 'Jämför favoriter',
    compareFavsPreamble: 'Här kan du jämföra dina favoritområden,  bläddra till höger för att se fler områden.',
    locationInformation: 'PLATSINFORMATION',
  },
  changeMunicipalityModal: {
    content: 'Du lämnar nu kommunen, vill du byta kommun?',
  },
};

export default sv;



// WEBPACK FOOTER //
// ./src/Resources/sv.js